import React, { FC, useState, useEffect, PropsWithChildren, useMemo } from 'react';
import { useQueryParam } from 'use-query-params';

import Container from 'components/common/Container';
import EventsPageHeader from 'components/headers/EventsPageHeader';
import { SortContextProvider } from 'components/context/SortContext';
import { EventsFilterableContext } from 'components/events/common/EventsListContext';

import { useRootPath } from 'graphql/hooks/navigation';

import { SessionStorageKeys } from 'types/enums';

import useStyles from './style';

const EventsLayout: FC<PropsWithChildren> = ({ children }) => {
  const classes = useStyles();

  const euStatus = sessionStorage.getItem(SessionStorageKeys.euStatus);
  const ehStatus = sessionStorage.getItem(SessionStorageKeys.ehStatus) ?? '';
  const djId = sessionStorage.getItem(SessionStorageKeys.eDj) ?? undefined;

  const [q] = useQueryParam<string>('q');

  const tab = useRootPath(1);

  const initialFilter = useMemo(
    () => ({
      statusId: euStatus ? +euStatus : undefined,
      past: ehStatus === 'past',
      isDeleted: ehStatus === 'isDeleted',
      djId,
      q,
    }),
    []
  );

  const [filter, setFilter] = useState<EventsFilter>(initialFilter);

  useEffect(() => {
    if (q) {
      sessionStorage.setItem(SessionStorageKeys.eQ, q);
    } else {
      sessionStorage.removeItem(SessionStorageKeys.eQ);
    }

    setFilter(prev => ({ ...prev, q }));
  }, [q]);

  useEffect(() => {
    sessionStorage.setItem(SessionStorageKeys.eTab, tab);
  }, [tab]);

  return (
    <div className={classes.eventsLayout}>
      <EventsFilterableContext.Provider value={{ filter, setFilter }}>
        <SortContextProvider sessionKey={SessionStorageKeys.eSorting}>
          <EventsPageHeader />
          <Container className={classes.container}>{children}</Container>
        </SortContextProvider>
      </EventsFilterableContext.Provider>
    </div>
  );
};

export default EventsLayout;
